// 색상 결정 등 뷰 로직에 필요한 가공 함수들
export function parseBatteryPct(pctStr) {
  const n = Math.max(
    0,
    Math.min(100, parseInt(String(pctStr).replace("%", ""), 10) || 0)
  );
  return n;
}

export function getBatteryColors(pctNum) {
  if (pctNum >= 70) return { bar: "#51FF00", border: "#9AEF7F" };
  if (pctNum >= 30) return { bar: "#FFC800", border: "#FFDD7A" };
  return { bar: "#FF5A5A", border: "#FF9E9E" };
}

export function getStatusDotColor(text) {
  return text ? "#2DFF6C" : "#FF5A5A";
}
